import { Component } from '@angular/core';
import { DataService } from 'src/app/services/data.service';
import { MessageService } from 'src/app/services/message.service';

@Component({
  selector: 'app-seo-off-page-backlinks-list',
  templateUrl: './seo-off-page-backlinks-list.component.html',
  styleUrls: ['./seo-off-page-backlinks-list.component.css'],
})
export class SeoOffPageBacklinksListComponent {
  url: string = 'seoBacklinks';
  data: Array<any> = [];
  searchText = '';
  filteredData: Array<any> = [];
  searchSuggestions: string[] = [];
  currentPage: number = 1;
  morePages: boolean = true;
  itemsPerPage: number = 50;
  modalTitle: string = '';
  modalContent: string | null = null;

  resumenCards = [
    {
      label: '',
      value: '', //0
      icon: 'fas fa-globe',
      bgClass: 'bg-white',
      desc: 'SEO',
      route: '/marketing',
    },
    {
      label: '',
      value: '', //0
      icon: 'fas fa-arrow-trend-up',
      bgClass: 'bg-white',
      desc: 'ADS',
      route: '/marketing/ads',
    },
    {
      label: '',
      value: '', //0
      icon: 'fa-solid fa-people-line',
      bgClass: 'bg-white',
      desc: 'SOCIAL',
      route: '/marketing/social/strategy',
    },
    {
      label: '',
      value: '', //0
      icon: 'fas fa-globe',
      bgClass: 'bg-white',
      desc: 'GEO',
      route: '',
    },
    
  ];

  constructor(
    private dataService: DataService,
    private messageService: MessageService,
  ) {}

  ngOnInit(): void {
    this.getData();
  }

  getData(): void {
    this.dataService
      .getDataTwo(this.url, '', '', this.currentPage, this.itemsPerPage)
      .subscribe((response) => {
        if (response.data) {
          this.data = response.data.sort((a: any, b: any) => {
            return (
              new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()
            );
          });
          this.filteredData = [...this.data];
          this.updateSuggestions();
        }
      });
  }

  markLive(id: string): void {
    if (!confirm('¿Desea marcar este backlink como activo (live)?')) {
      return;
    }
    this.dataService
      .putData(`${this.url}/${id}/mark-live`, {})
      .subscribe((response) => {
        if (response.rst) {
          this.messageService.add(response.msg, 'info');
          this.getData();
        } else {
          this.messageService.add(response.msg, 'secondary');
        }
      });
  }

  markLost(id: string): void {
    if (!confirm('¿Desea marcar este backlink como perdido (lost)?')) {
      return;
    }
    this.dataService
      .putData(`${this.url}/${id}/mark-lost`, {})
      .subscribe((response) => {
        if (response.rst) {
          this.messageService.add(response.msg, 'info');
          this.getData();
        } else {
          this.messageService.add(response.msg, 'secondary');
        }
      });
  }

  deleteData(id: string): void {
    if (!confirm('¿Desea eliminar este backlink?')) {
      return;
    }
    this.dataService
      .deleteData(`${this.url}/delete/${id}`)
      .subscribe((response) => {
        if (response.rst) {
          this.messageService.add(response.msg, 'info');
          this.getData();
        } else {
          this.messageService.add(response.msg, 'secondary');
        }
      });
  }

  filter() {
    const texto = this.searchText.trim().toLowerCase();
    if (!texto) {
      this.filteredData = [...this.data];
    } else {
      this.filteredData = this.data.filter((item) => {
        return (
          (item.sourceDomain &&
            item.sourceDomain.toLowerCase().includes(texto)) ||
          (item.anchorText && item.anchorText.toLowerCase().includes(texto)) ||
          (item.backlinkStatus &&
            item.backlinkStatus.toLowerCase().includes(texto))
        );
      });
    }
  }

  updateSuggestions() {
    const sugerenciasSet = new Set<string>();
    this.data.forEach((item) => {
      if (item.sourceDomain) sugerenciasSet.add(item.sourceDomain);
      if (item.anchorText) sugerenciasSet.add(item.anchorText);
    });
    this.searchSuggestions = Array.from(sugerenciasSet).filter(Boolean);
  }

  getStatusBadgeClass(statusStr: string): string {
    const status = statusStr?.toLowerCase();
    switch (status) {
      case 'pending':
        return 'badge-secondary';
      case 'live':
        return 'badge-success';
      case 'lost':
        return 'badge-danger';
      case 'rejected':
        return 'badge-dark';
      default:
        return 'badge-light text-dark';
    }
  }

  showModal(title: string, content: string) {
    this.modalTitle = title;
    this.modalContent = content;
  }

  closeModal() {
    this.modalContent = null;
  }
}
